export default __webpack_public_path__ + "images/extra-install-close.3c0b943c49580870eb7f119bbae6e088.svg";